/**
 * Module connaissances — généré depuis le plan directeur GÉCÉRAM CRM (2026-07-28).
 * S'intègre par le registre : aucun fichier du noyau modifié.
 */
import { lazy } from "react";
import type { ModuleDef } from "../../core/module-contract";

const mod: ModuleDef = {
  id: "connaissances",
  label: "Base de connaissances",
  icon: "i-book",
  navGroup: "ressources",
  navOrder: 60,
  rolesRequis: [],
  routes: [{ path: "/connaissances", component: lazy(() => import("./routes/Index")) }],
};

export default mod;
